import { useOrganizationName } from "@/hooks/useOrganizationName";

export function useKbAdminPanelMeta(params: {
  orgId?: string | null;
  auth: any;
  orgSettings: { brandName?: string; appDisplayName?: string };
  canPublishKb: boolean;
  canManageAppScope: boolean;
  canManageManufacturerScope: boolean;
  loadedArticle: any;
}) {
  const { orgId, auth, orgSettings, canPublishKb, canManageAppScope, canManageManufacturerScope, loadedArticle } = params;
  const editorName = auth?.profile?.full_name?.trim() || auth?.profile?.display_name?.trim() || auth?.profile?.email?.split("@")[0]?.trim() || "";
  const hasEditorName = editorName.length >= 2;
  const publishedArticleLocked = !canPublishKb && loadedArticle?.status === "published";
  const broaderScopeLocked = !!loadedArticle && ((loadedArticle.scope === "app" && !canManageAppScope) || (loadedArticle.scope === "manufacturer" && !canManageManufacturerScope));
  const resolvedOrgName = useOrganizationName(orgId ?? null);
  const kbOrgDisplayName = [resolvedOrgName, orgSettings.brandName, orgSettings.appDisplayName, orgId ? "Selected organization" : ""].map((s) => (s || "").trim()).find((s) => s.length > 0) || "Organization";
  const defaultArticleTitle = `${kbOrgDisplayName} knowledge base draft`;
  const aiGuidance = canManageManufacturerScope
    ? ["You can prepare org and manufacturer documents from here.", "App-scope documents remain platform-managed.", "Use org scope for company-specific process, pricing, or internal training content.", "Use manufacturer scope when the content is intentionally shared as a manufacturer baseline."]
    : ["Your drafts are limited to your active organization.", "Use org scope for internal process, pricing overrides, scripts, and training notes.", "Manufacturer and app documents are restricted by role and will be blocked if you try to save them here."];
  return { editorName, hasEditorName, publishedArticleLocked, broaderScopeLocked, kbOrgDisplayName, defaultArticleTitle, aiGuidance };
}
